import { render, staticRenderFns } from "./ProgressionHierarchy.vue?vue&type=template&id=4351b123"
import script from "./ProgressionHierarchy.vue?vue&type=script&lang=js"
export * from "./ProgressionHierarchy.vue?vue&type=script&lang=js"
import style0 from "./ProgressionHierarchy.vue?vue&type=style&index=0&id=4351b123&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports